import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import MobileFrame from "./MobileFrame";

const StepCard = ({ number, image, imageAlt, label, padding }) => {
  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        mt: { xs: number > 1 ? 6 : 0, lg: 0 },
      }}
    >
      <MobileFrame
        sx={{
          transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
          "&:hover": {
            transform: "translateY(-8px) scale(1.02)",
          },
        }}
      >
        {padding ? (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: padding,
              boxSizing: "border-box",
            }}
          >
            <img
              src={image.startsWith("/") ? image : `/${image}`}
              alt={imageAlt}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                display: "block",
              }}
            />
          </Box>
        ) : (
          <img
            src={image.startsWith("/") ? image : `/${image}`}
            alt={imageAlt}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
        )}
      </MobileFrame>

      <Box
        sx={{
          mt: 3,
          maxWidth: "280px",
          background:
            "linear-gradient(135deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05))",
          backdropFilter: "blur(10px)",
          borderRadius: "16px",
          border: "1px solid rgba(255, 255, 255, 0.2)",
          p: 2.5,
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
          transition: "all 0.3s ease",
          "&:hover": {
            transform: "translateY(-2px)",
            boxShadow: "0 12px 40px rgba(0, 0, 0, 0.15)",
            background:
              "linear-gradient(135deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.08))",
          },
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: "#fff",
            fontWeight: 600,
            letterSpacing: "0.3px",
            textAlign: "center",
            fontSize: "15px",
            lineHeight: 1.6,
            fontFamily: "Inter, sans-serif",
            textShadow: "0 2px 4px rgba(0, 0, 0, 0.3)",
          }}
        >
          {label}
        </Typography>
      </Box>
    </Box>
  );
};

StepCard.propTypes = {
  number: PropTypes.number.isRequired,
  image: PropTypes.string.isRequired,
  imageAlt: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  padding: PropTypes.string,
};

export default StepCard;
